<template>
  <div id="app" class="min-h-screen flex flex-col">
    <HeaderSection />
    <main class="flex-1 bg-[radial-gradient(ellipse_at_center,#0d9488_0%,#0b766c_100%)]">
      <router-view />
    </main>
    <FooterSection/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterSection from '@/components/FooterSection.vue'
import HeaderSection from './components/HeaderSection.vue';

export default defineComponent({
  name: 'App',
  components: {
    FooterSection, HeaderSection
  }
});
</script>
